// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Particles = require("../../../uikit/reason/Styles/Particles.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ReactResponsive = require("react-responsive");
let ReactResponsive$1 = require("react-responsive").default;
let JsxRuntime = require("react/jsx-runtime");

function toProps(v) {
  switch (v.TAG) {
    case "MediaQuery" :
      return {
        query: v._0
      };
    case "MinWidth" :
      return {
        minWidth: Primitive_option.some(v._0)
      };
    case "MaxWidth" :
      return {
        maxWidth: Primitive_option.some(v._0)
      };
  }
}

let JS = {};

function useMediaQuery(input) {
  return ReactResponsive.useMediaQuery(toProps(input));
}

function matches(input) {
  let query;
  switch (input.TAG) {
    case "MediaQuery" :
      query = input._0;
      break;
    case "MinWidth" :
      query = `(min-width: ` + Particles.Breakpoint.toString(input._0) + `)`;
      break;
    case "MaxWidth" :
      query = `(max-width: ` + Particles.Breakpoint.toString(input._0) + `)`;
      break;
  }
  return Stdlib_Option.getOr(Stdlib_Option.map(Primitive_option.fromNullable(globalThis.window), window => window.matchMedia(query).matches), false);
}

let reducedMotionQuery = "(prefers-reduced-motion: reduce)";

function prefersReducedMotion() {
  return matches({
    TAG: "MediaQuery",
    _0: reducedMotionQuery
  });
}

function usePrefersReducedMotion() {
  return ReactResponsive.useMediaQuery(toProps({
    TAG: "MediaQuery",
    _0: reducedMotionQuery
  }));
}

function isMobile() {
  return ReactResponsive.useMediaQuery(toProps({
    TAG: "MaxWidth",
    _0: Particles.Breakpoint.sm
  }));
}

function isDesktop() {
  return ReactResponsive.useMediaQuery(toProps({
    TAG: "MinWidth",
    _0: Particles.Breakpoint.md
  }));
}

function isLG() {
  return ReactResponsive.useMediaQuery(toProps({
    TAG: "MinWidth",
    _0: Particles.Breakpoint.lg
  }));
}

function isXL() {
  return ReactResponsive.useMediaQuery(toProps({
    TAG: "MinWidth",
    _0: Particles.Breakpoint.xl
  }));
}

function isSM() {
  return ReactResponsive.useMediaQuery(toProps({
    TAG: "MinWidth",
    _0: Particles.Breakpoint.sm
  }));
}

function MediaQuery(props) {
  let children = props.children;
  let __renderWhenQueryIs = props.renderWhenQueryIs;
  let query = props.query;
  let renderWhenQueryIs = __renderWhenQueryIs !== undefined ? __renderWhenQueryIs : true;
  let renderFunction = queryMatches => {
    if (queryMatches === renderWhenQueryIs) {
      return children;
    } else {
      return null;
    }
  };
  switch (query.TAG) {
    case "MediaQuery" :
      return JsxRuntime.jsx(ReactResponsive$1, {
        query: query._0,
        children: renderFunction
      });
    case "MinWidth" :
      return JsxRuntime.jsx(ReactResponsive$1, {
        minWidth: Primitive_option.some(query._0),
        children: renderFunction
      });
    case "MaxWidth" :
      return JsxRuntime.jsx(ReactResponsive$1, {
        maxWidth: Primitive_option.some(query._0),
        children: renderFunction
      });
  }
}

let Breakpoint;

let make = MediaQuery;

exports.Breakpoint = Breakpoint;
exports.toProps = toProps;
exports.JS = JS;
exports.useMediaQuery = useMediaQuery;
exports.matches = matches;
exports.reducedMotionQuery = reducedMotionQuery;
exports.prefersReducedMotion = prefersReducedMotion;
exports.usePrefersReducedMotion = usePrefersReducedMotion;
exports.isMobile = isMobile;
exports.isDesktop = isDesktop;
exports.isLG = isLG;
exports.isXL = isXL;
exports.isSM = isSM;
exports.make = make;
/* react-responsive Not a pure module */
